const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("is-visible");
    } else if (entry.boundingClientRect.top > 0) {
      // элемент ушёл ниже области просмотра
      entry.target.classList.remove("is-visible");
    }
    // если элемент выше области просмотра (top < 0) — оставляем is-visible
  });
});

export default function (element, data) {
  element.classList.add("animation-trigger");
  observer.observe(element);
}
